import { CREATE_MATERIAL_URL, DELETE_MATERIAL_URL, LIST_MATERIAL_URL, MATERIAL_ACTIVE, MATERIAL_DROPDOWN, SINGLE_MATERIAL_URL, USED_MATERIAL_LIST } from "../api";
import axiosInstance from "../axiosInstance";

export const createMaterial = (props) => onResponse => {
    try {
        axiosInstance.post(CREATE_MATERIAL_URL, props?.values)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err?.response?.data);
            });

    } catch (error) {

    }

};
export const listMaterial = (props) => onResponse => {
    try {
        let BASE_URL = LIST_MATERIAL_URL + '?'
        if (props?.page) {
            BASE_URL += 'page=' + props.page + '&'
        }
        if (props?.limit) {
            BASE_URL += 'limit=' + props.limit + '&'
        }
        if (props?.search) {
            BASE_URL += 'search=' + props.search + '&'
        }
        if (props?.order) {
            BASE_URL += 'order=' + props.order + '&'
        }
        if (props?.sort) {
            BASE_URL += 'sort_by=' + props.sort + '&'
        }
        if (props?.museum_id) {
            BASE_URL += 'museum_id=' + props.museum_id + '&'
        }
        if (props?.start_date) {
            BASE_URL += 'start_date=' + props.start_date + '&'
        }
        if (props?.end_date) {
            BASE_URL += 'end_date=' + props.end_date + '&'
        }
        if (props?.not_used) {
            BASE_URL += 'not_used=' + props.not_used + '&'
        }

        if (props?.museum) {
            BASE_URL += 'museum=' + props.museum + '&'
        }
        axiosInstance.get(BASE_URL)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err?.response?.data);
            });

    } catch (error) {

    }

};
export const getSingleMaterial = (props) => onResponse => {
    try {
        let BASE_URL = SINGLE_MATERIAL_URL + '?'
        if (props?.page) {
            BASE_URL += 'page=' + props.page + '&'
        }
        if (props?.id) {
            BASE_URL += 'id=' + props.id + '&'
        }

        axiosInstance.get(BASE_URL)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err?.response?.data);
            });

    } catch (error) {

    }

};
export const deleteMaterial = (props) => onResponse => {
    try {


        axiosInstance.delete(DELETE_MATERIAL_URL, { data: { id: props?.id } })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err?.response?.data);
            });

    } catch (error) {

    }

};

export const listMaterialDropdown = (props) => onResponse => {

    try {
        let BASE_URL = MATERIAL_DROPDOWN + '?'
        if (props.page) {
            BASE_URL += 'page=' + props.page + '&'
        }
        if (props.limit) {
            BASE_URL += 'limit=' + props.limit + '&'
        }
        if (props.search) {
            BASE_URL += 'search=' + props.search + '&'
        }
        if (props.sort_by) {
            BASE_URL += 'sort_by=' + props.sort_by + '&'
        }
        if (props.museum_id) {
            BASE_URL += 'museum_id=' + props.museum_id + '&'
        }
        axiosInstance.get(BASE_URL)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err?.response?.data);
            });
    } catch (error) {

    }
}

export const materialeinactivehandler = (props) => onResponse => {
    try {
        axiosInstance.put(MATERIAL_ACTIVE, props)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err?.response?.data);
            });

    } catch (error) {


    }

};
export const materialUsedMuseumlist = (props) => onResponse => {
    console.log(props, "propssss");

    try {
        let BASE_URL = USED_MATERIAL_LIST + '?'
        if (props.page) {
            BASE_URL += 'page=' + props.page + '&'
        }
        if (props.limit) {
            BASE_URL += 'limit=' + props.limit + '&'
        }
        if (props.material_id) {
            BASE_URL += 'material_id=' + props.material_id + '&'
        }
        axiosInstance.get(BASE_URL, props)
            .then((response) => {
                onResponse(response?.data)
            })
            .catch((err) => {
                onResponse(err?.response?.data)
            })

    } catch (err) {

    }
}
